<template>
  <PostHeader :story="story" :myProfileId="myProfileId" :slider="0" v-model:description="description"
    :piklistId="piklistId" :imageId="pik_id" :piklist_user_id="piklist_user_id" :storefront="storefront"
    :piklist_profile_pic="piklist_profile_pic" :user_id="user_id" :user_name="user_name" :pikd_pik_id="pikd_pik_id"
    :piklist_fullname="piklist_fullname" :piklist_userbadge="piklist_userbadge" :piklist_ecbbadge="piklist_ecbbadge"
    :piklist_username="piklist_username" :originator_id="originator_id" :originator_username="originator_username"
    :isAd="isAd" :date_time="date_time" v-model:visibility="visibility" v-model:piklist_name="piklist_name"
    :post_address="story.post_address" :live_video="live_video" :premiere_date="premiere_date" :type="type" />
  <div @touchmove.passive="registerView()" @mouseover="registerView()">
    <PostDescription
      v-if="(pikd_pik_id == 0 || pikd_pik_id == null) && (checkPremium() && type != 3 || (type == 3 && link_url != '') || (type == 3 && Object.keys(story.allimages).length == 1))"
      :description="description" :piklist_id="piklistId" :pik_id="pik_id" :pikd_pik_id="pikd_pik_id"
      :originator_id="originator_id" :originator_username="originator_username" :current_index="current_index"
      slider="1" :text_only="isTextOnly()" />
  </div>
  <div v-if="story != null && (Object.keys(story.allimages).length > 0)" @touchmove.passive="registerView()"
    @mouseover="registerView()">
    <div v-if="pikd_pik_id != 0 && pikd_pik_id != null" class="repost-box">
      <div style="width:100%; display:inline-block; min-height:200px; position:relative;" v-show="type == 1
        || (type == 2 && showPlayer.indexOf('videoPlayer' + pik_id + '_' + streamIndex) == -1)">
        <img style="border-radius: 0;" :class="'feature-img photo-image-' + pik_id + ' ' + adClick(isAd)"
          :id="'image_' + pik_id" :src="path + '/piks/' + pik_name" loading="lazy" @click="didClick(story.isAd)" />
        <div v-if="type == 2" v-show="(showPlayer.indexOf('videoPlayer' + pik_id + '_' + streamIndex) == -1)"
          @click="setVideoOptions(pik_name, 'videoPlayer' + pik_id + '_' + streamIndex, false)">
          <ion-icon class="video-play-icon-single" :icon="play"></ion-icon>
        </div>
      </div>
      <div v-if="type == 2" v-show="parseInt(showPlayer.indexOf('videoPlayer' + pik_id + '_' + streamIndex)) > -1">
        <video :class="'video-js vjs-default-skin ' + calculateAspectRatio()" :width="width" :height="height"
          :ref="'videoPlayer' + pik_id + '_' + streamIndex" :id="'videoPlayer' + '_' + streamIndex"
          :poster="path + '/piks/' + pik_name" playsinline muted></video>
      </div>
      <div v-if="type == 3 &&
        link_url != '' &&
        link_url != null &&
        link_image != '' &&
        link_image != null" style="margin: 0; width:100%; border:none; border-radius:0;" class="url-block-large">
        <div v-if="link_video != '' && link_video != null && !isEmbed(link_video)">
          <div style="position: relative;"
            v-show="parseInt(showPlayer.indexOf('linkPlayer' + pik_id + '_' + streamIndex)) > -1">
            <video class="video-js vjs-default-skin vjs-fluid" :ref="'linkPlayer' + pik_id + '_' + streamIndex"
              :id="'linkPlayer' + pik_id + '_' + streamIndex" :poster="link_image" playsinline muted></video>
          </div>
        </div>
        <div v-if="link_video != '' && link_video != null && isEmbed(link_video)">
          <iframe :src="link_video"></iframe>
        </div>
        <div @click="openLink(link_url)"
          style="width:100%; height:auto; display:inline-block; min-height:200px; position:relative;"
          v-if="link_image != '' && link_image != null && linkVideoCheck(link_video, 'linkPlayer' + pik_id + '_' + streamIndex)">
          <img style="border-radius:0px;" loading="lazy" :src="link_image" />
          <div
            v-show="link_video != '' && link_video != null && !isEmbed(link_video) && showPlayer.indexOf('linkPlayer' + pik_id + '_' + streamIndex) == -1"
            @click="setVideoOptions(link_video, 'linkPlayer' + pik_id + '_' + streamIndex, true)">
            <ion-icon class="video-play-icon-single" :icon="play"></ion-icon>
          </div>
        </div>
        <div @click="openLink(link_url)" class="link">
          {{ getHostName(link_url) }}
        </div>
        <div @click="openLink(link_url)" class="link_text" v-show="link_text != ''">{{ link_text }}</div>
      </div>
      <div v-if="(type == 3 &&
        link_url != '' &&
        link_url != null &&
        (link_image == '' || link_image == null)) && (link_url.search('.mp3') == -1 && link_url.search('.m4a') == -1)
        " class="url-block" @click="openLink(link_url)">
        <div class="link">{{ getHostName(link_url) }}</div>
        <div class="link_text">{{ link_text }}</div>
      </div>
      <div style="padding-top: 5px; padding-bottom: 5px; background: none" v-if="(link_url != '' &&
        link_url != null) &&
        (link_url.search('.mp3') != -1 || link_url.search('.m4a') != -1)">
        <audio ref="audioPlayer" style="display: block; width: 90%; margin-left: auto; margin-right: auto;" controls>
          <source :src="link_url" type="audio/mpeg" />
          {{ $t("alertmessage.unsupported") }}
        </audio>
      </div>
      <PostHeader :story="story" :myProfileId="myProfileId" :slider="0" v-model:description="description"
        :piklistId="piklistId" :imageId="pik_id" :piklist_user_id="piklist_user_id" :storefront="storefront"
        :piklist_profile_pic="piklist_profile_pic" :user_id="user_id" :user_name="user_name" :pikd_pik_id="pikd_pik_id"
        :piklist_fullname="piklist_fullname" :piklist_userbadge="piklist_userbadge" :piklist_ecbbadge="piklist_ecbbadge"
        :piklist_username="piklist_username" :originator_id="originator_id" :originator_username="originator_username"
        :isAd="isAd" :date_time="date_time" v-model:visibility="visibility" v-model:piklist_name="piklist_name"
        :repost="true" :post_address="story.post_address" />
      <PostDescription
        v-if="checkPremium() && type != 3 || (type == 3 && link_url != '') || (type == 3 && Object.keys(story.allimages).length == 1)"
        :description="description" :piklist_id="piklistId" :pik_id="pik_id" :pikd_pik_id="pikd_pik_id"
        :originator_id="originator_id" :originator_username="originator_username" :current_index="current_index"
        slider="1" :text_only="isTextOnly()" />
    </div>
    <div :style="checkVertical()" ref="videoContainer" v-else>
      <div style="width:100%; display:inline-block; min-height:200px; position:relative;" v-if="type == 1">
        <div v-if="story.isPremium == 'yes' && story.canViewPremium == 'no'" :style="'background-image:url(\'' + path + '/piks/' + pik_name + '\');'
          " class="subscriber-background"></div>
        <div @click="openBuyModal(user_id)"
          v-if="story.isPremium == 'yes' && story.canViewPremium == 'no' && !checkIosApp()" class="subscriber-bg-text">
          <h1>{{ $t("buttons.premiumstory") }}</h1>
          <p>{{ $t("buttons.clickhere") }}</p>
        </div>
        <div v-if="story.isPremium == 'yes' && story.canViewPremium == 'no' && checkIosApp()"
          class="subscriber-bg-text">
          <h1>{{ $t("buttons.premiumstory") }}</h1>
          <p>&nbsp;</p>
        </div>
        <img :class="'feature-img photo-image-' + pik_id + ' ' + adClick(isAd)" :id="'image_' + pik_id"
          :src="path + '/piks/' + pik_name" loading="lazy" @click="didClick(story.isAd)" />
      </div>
      <div v-if="type == 2 && encoder != null && !live_video">
        <img v-if="videoLocked" :src="path + '/piks/' + pik_name" :alt="description" style="width:100%;height:auto;object-fit:contain;border-radius:8px;" />
        <video v-else :class="'video-js vjs-default-skin ' + calculateAspectRatio()" :width="width" :height="height"
          :ref="'videoPlayer' + pik_id + '_' + streamIndex" :id="'videoPlayer' + pik_id + '_' + streamIndex"
          :poster="path + '/piks/' + pik_name" playsinline muted preload="metadata"></video>
        <div v-if="showSkipAd && !videoLocked" class="skip-ad-btn" @click="skipAd('videoPlayer' + pik_id + '_' + streamIndex)">Skip Ad</div>
      </div>
      <div class="video-processing " v-if="type == 2 && encoder == null">
        <div class="ion-text-center ion-padding">
          <h3>Video processing underway.</h3>
          <p>Check back shortly!</p>
        </div>
      </div>
      <div v-if="type == 4 || (type == 2 && live_video)">
        <img v-if="videoLocked" :src="path + '/piks/' + pik_name" :alt="description" style="width:100%;height:auto;object-fit:contain;border-radius:8px;" />
        <video v-else :class="'video-js vjs-default-skin '+ calculateAspectRatio()" :width="width" :height="height"
          :ref="'live_video' + pik_id + '_' + streamIndex" :id="'live_video' + pik_id + '_' + streamIndex"
          :poster="path + '/piks/' + pik_name" playsinline muted preload="metadata"></video>
        <div v-if="showSkipAd" class="skip-ad-btn" @click="skipAd('live_video' + pik_id + '_' + streamIndex)">Skip Ad</div>
      </div>
      <div v-if="type == 3 &&
        link_url != '' &&
        link_url != null &&
        link_image != '' &&
        link_image != null" class="url-block-large">
        <div v-if="link_video != '' && link_video != null && !isEmbed(link_video)">
          <div v-show="parseInt(showPlayer.indexOf('linkPlayer' + pik_id + '_' + streamIndex)) > -1">
            <video class="video-js vjs-default-skin vjs-fluid" :ref="'linkPlayer' + pik_id + '_' + streamIndex"
              :id="'linkPlayer' + pik_id + '_' + streamIndex" :poster="link_image" playsinline muted></video>
          </div>
        </div>
        <div v-if="link_video != '' && link_video != null && isEmbed(link_video)">
          <iframe :src="link_video"></iframe>
        </div>
        <div @click="openLinkVideo(link_url, (link_video != '' && link_video != null && !isEmbed(link_video)))"
          style="position:relative; width:100%; height:auto; display:inline-block; min-height:200px;"
          v-if="link_image != '' && link_image != null && linkVideoCheck(link_video, 'linkPlayer' + pik_id + '_' + streamIndex)">
          <img @error="imgUrlAlt2" style="width:100%; border-radius: 0;" loading="lazy" :src="link_image" />
          <div class="video-play"
            v-show="link_video != '' && link_video != null && !isEmbed(link_video) && showPlayer.indexOf('linkPlayer' + pik_id + '_' + streamIndex) == -1"
            @click="setVideoOptions(link_video, 'linkPlayer' + pik_id + '_' + streamIndex, true)">
            <ion-icon class="video-play-icon" :icon="play"></ion-icon>
          </div>
        </div>
        <div @click="openLink(link_url)" class="link">
          {{ getHostName(link_url) }}
        </div>
        <div @click="openLink(link_url)" class="link_text" v-show="link_text != ''">{{ link_text }}</div>
      </div>
      <div v-if="(type == 3 &&
        link_url != '' &&
        link_url != null &&
        (link_image == '' || link_image == null)) && (link_url.search('.mp3') == -1 && link_url.search('.m4a') == -1)
        " class="url-block" @click="openLink(link_url)">
        <div class="link">{{ getHostName(link_url) }}</div>
        <div class="link_text">{{ link_text }}</div>
      </div>
      <div style="padding-top: 5px; padding-bottom: 5px; background: none" v-if="(link_url != '' &&
        link_url != null) &&
        (link_url.search('.mp3') != -1 || link_url.search('.m4a') != -1)">
        <audio ref="audioPlayer" style="display: block; width: 90%; margin-left: auto; margin-right: auto;" controls>
          <source :src="link_url" type="audio/mpeg" />
          {{ $t("alertmessage.unsupported") }}
        </audio>
      </div>
    </div>
  </div>
  <PostFooter :story="story" :totalpiks="totalpiks" :totalvids="totalvids" v-model:likeittype="likeittype"
    v-model:likeit="likeit" v-model:likes="likes" v-model:totalcomments="totalcomments" v-model:numberFav="numberFav"
    v-model:watching="watching" v-model:numberRepost="numberRepost" v-model:link_url="link_url"
    v-model:link_image="link_image" v-model:link_text="link_text" :isAd="story.isAd" :type="type"
    :numberViews="numberViews" :current_index="current_index" :pik_id="pik_id" slider="1" />
</template>
<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { modalController, loadingController, IonIcon, isPlatform } from '@ionic/vue';
import getEnv from "@/utils/env";
import {
  play,
  chevronForwardOutline,
  chevronBackOutline
} from "ionicons/icons";

import videojs from "video.js/dist/video.min.js";
import "video.js/dist/video-js.min.css";
import PostDescription from "@/components/PostDescription.vue";
import PostHeader from "@/components/PostHeader.vue";
import PostFooter from "@/components/PostFooter.vue";
import BuyModal from '@/components/BuyModal.vue'
import PhotoView from '@/components/PhotoView.vue'
import { Browser } from '@capacitor/browser';
//import PhotoView from '@/components/PhotoView.vue'

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend day.js with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

export default defineComponent({
  name: "PostContainer",
  emits: ['update:refocus', 'update:story'],
  props: {
    streamName: String,
    streamIndex: Number,
    story: Object,
    scrollContainer: Object, // Receive the scrollable container
    userid: Number,
    myProfileId: { Number, default: 0 },
    imageSelected: { Number, default: 0 },
  },
  components: {
    //Swiper,
    //SwiperSlide,
    PostDescription,
    IonIcon,
    PostHeader,
    PostFooter
  },
  setup() {
    return { play, chevronForwardOutline, chevronBackOutline };
  },
  data() {
    return {
      showPlayer: [],
      player: [],
      loading: true,
      loadingIndicator: { Object, default: null },
      pagingloading: null,
      path: getEnv("AWS_URL") + getEnv("PHOTO_BUCKET"),
      link_url: this.story.allimages[0].link_url,
      link_text: this.story.allimages[0].link_text,
      link_image: this.story.allimages[0].link_image,
      link_video: this.story.allimages[0].link_video,
      pik_id: this.story.allimages[0].id,
      description: this.story.allimages[0].description,
      current_index: 0,
      piklistId: this.story.piklist_id,
      piklist_user_id: this.story.piklist_user_id,
      storefront: this.story.storefront,
      piklist_profile_pic: this.story.piklist_profile_pic,
      user_id: this.story.allimages[0].user_id,
      pikd_pik_id: this.story.allimages[0].pikd_pik_id,
      piklist_fullname: this.story.piklist_fullname,
      piklist_userbadge: this.story.piklist_userbadge,
      piklist_ecbbadge: this.story.piklist_ecbbadge,
      piklist_username: this.story.piklist_username,
      originator_id: this.story.allimages[0].originator_id,
      originator_username: this.story.allimages[0].originator_username,
      isAd: this.story.isAd,
      date_time: this.story.allimages[0].date_time,
      visibility: this.story.visibility,
      piklist_name: this.story.piklist_name,
      pik_name: this.story.allimages[0].pik_name,
      pik_path: this.story.allimages[0].pik_path,
      origin_date: this.story.allimages[0].origin_date,
      width: this.story.allimages[0].width,
      height: this.story.allimages[0].height,
      totalcomments: this.story.allimages[0].totalcomments,
      likes: this.story.allimages[0].likes,
      cute: this.story.allimages[0].cute,
      lol: this.story.allimages[0].lol,
      loveit: this.story.allimages[0].loveit,
      greatshot: this.story.allimages[0].greatshot,
      cool: this.story.allimages[0].cool,
      dislike: this.story.allimages[0].dislike,
      wow: this.story.allimages[0].wow,
      likeit: this.story.allimages[0].likeit,
      likeittype: this.story.allimages[0].likeittype,
      numberRepost: this.story.allimages[0].numberRepost,
      numberViews: this.story.allimages[0].numberViews,
      numberFav: this.story.numberFav,
      watching: this.story.watching,
      totalpiks: this.story.totalpiks,
      totalvids: this.story.totalvids,
      user_name: this.story.allimages[0].user_name,
      type: this.story.allimages[0].type,
      encoder: this.story.allimages[0].encoder,
      live_video: this.story.allimages[0].live_video,
      randomizedAds: [], // Store randomized ads
      premiere_date: this.story.allimages[0].premiere_date ? dayjs(this.story.allimages[0].premiere_date).utcOffset(-5, true) : null, // Treat as UTC-5
      time_est: dayjs(), 
      showSkipAd: false,
    };
  },
  async mounted() {
    let currentImage;
    if (this.story.allimages[0].current_index == this.current_index) {
      currentImage = this.story.allimages[0];
    }
    if(currentImage!=undefined){
      this.pik_name = currentImage.pik_name;
      this.description = currentImage.description;
      this.width = currentImage.width;
      this.height = currentImage.height;
      this.type = currentImage.type;
      this.date_time = currentImage.date_time;
      this.link_url = currentImage.link_url;
      this.link_text = currentImage.link_text;
      this.link_image = currentImage.link_image;
      this.link_video = currentImage.link_video;
      this.pikd_pik_id = currentImage.pikd_pik_id;
      await this.getImageData(currentImage);
      
      if(this.$route.name=="story" || this.$route.name=="storyview"){
        console.log(this.$route.name, 'story name');
          
        let video = '';
        let title;
        let user = this.piklist_fullname;
        title = user + ' on ' + getEnv('APP_NAME') + ': ' + this.description.substring(0, 40) + "...";
        if (this.type == 2) {
          video = getEnv("AWS_URL") + getEnv("VIDEO_BUCKET") + "/" + this.pik_name.slice(0, -4) + "/video.m3u8";
        }
        this.$store.dispatch("header/custom", {
            title: title,
            description: this.description,
            url: 'https://' + getEnv('') + this.$route.fullPath,
            pik_name: this.path + '/piks/' + this.pik_name,
            width: this.width,
            height: this.height,
            video: video,
            id: this.pik_id
          });
        }
        await this.loadAndRandomizeAds(); // load the ad check first
        // Initialize video based on type
        if (this.type == 4 || (this.type == 2 && this.live_video)) {
          // Live video
          console.log(this.type, 'type');
          console.log(this.live_video, 'live video');
        
          const liveVideoRef = "live_video" + this.pik_id + "_" + this.streamIndex;
          //console.log(liveVideoRef, 'live video ref');
          await this.setVideoOptions(this.live_video, liveVideoRef, true);
        }else if(this.type == 2 && this.encoder != null && !this.live_video) {
          // Video
          const videoPlayerRef = "videoPlayer" + this.pik_id + "_" + this.streamIndex;
          //console.log(videoPlayerRef, 'video player ref');
          await this.setVideoOptions(this.pik_name, videoPlayerRef, false);
        }
      
      if(this.$route.name != "story" && this.$route.name != "storyview"){
        this.$nextTick(() => {
          this.attachScrollListener();
          this.detectVisibility(); // Initial check
        });
      }
    }

  },
  beforeUnmount() {
    this.detachScrollListener();
  },
  methods: {
    ...mapActions("ads", ["fetchAds"]),
    detectVisibility() {
      const videoContainer = this.$refs.videoContainer;
      if (!videoContainer) {
        //console.warn("Video container not found.");
        return;
      }

      const videoElements = videoContainer.querySelectorAll("video");
      videoElements.forEach((videoElement) => {
        const rect = videoElement.getBoundingClientRect();
        const isVisible =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth);

        if (isVisible) {
          if (videoElement.paused) {
            //console.log("Playing video:", videoElement);
            videoElement.play().catch((error) => {
              console.error("Error playing video:", error);
            }); 
          }
        } else {
          if (!videoElement.paused) {
            console.log("Pausing video:", videoElement);
            videoElement.pause();
          }
        }
      });
    },
    async attachScrollListener() {
      const scrollElement = this.scrollContainer || window; // Use the passed scroll container or fallback to window
      //console.log("Scroll Element:", scrollElement);
      scrollElement.addEventListener("scroll", this.detectVisibility, { passive: true });
      window.addEventListener("resize", this.detectVisibility); // Handle viewport resizing
    },
    async detachScrollListener() {
      const scrollElement = this.scrollContainer || window; // Use the passed scroll container or fallback to window
      //console.log("Detaching scroll listener from:", scrollElement);
      scrollElement.removeEventListener("scroll", this.detectVisibility);
      window.removeEventListener("resize", this.detectVisibility);
    },
    calculateAspectRatio() {
      var aspectClass = "vjs-fluid";
      if (this.width > this.height) {
        aspectClass = "vjs-16-9";
      } else if (this.width < this.height) {
        aspectClass = "vjs-9-16 max-height-video";
      } else if (this.width == this.height) {
        aspectClass = "vjs-1-1";
      }
      return aspectClass;
    },
    checkVertical() {
      let style = "";
      if (this.width < this.height) {
        style = "width: 65%; margin-left:auto; margin-right:auto;";
      }
      return style;
    },
    calcVideoHeight() {
      const maxHeight = window.innerHeight * 0.5; // 50% of the viewport height
      const aspectRatio = this.height / this.width;

      if (aspectRatio > 1) {
        // Vertical video
        return `${maxHeight}px`;
      } else {
        // Horizontal or square video
        return `${maxHeight * aspectRatio}px`;
      }
    },
    shuffleAds(ads) {
      for (let i = ads.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [ads[i], ads[j]] = [ads[j], ads[i]];
      }
      return ads;
    },

    async loadAndRandomizeAds() {
      try {
        // Check if ads are already loaded
        if (!this.$store.state.ads.adsLoaded) {
          console.log("Fetching ads for the first time...");
          await this.fetchAds(); // Fetch ads only if not already loaded
        } else {
          console.log("Ads already loaded, skipping fetch.");
        }

        // Randomize the ads
        this.randomizedAds = this.shuffleAds([...this.$store.state.ads.ads]); // Use a copy of the ads array
        //console.log("Randomized Ads:", this.randomizedAds);
      } catch (error) {
        console.error("Error loading ads:", error);
      }
    },
    async setVideoOptions(fileName, videoPlayerRef, isLink) {
      for (var i = 0; i < this.player.length; i++) {
        if (this.player[i].id_ == videoPlayerRef) {
          return; // Prevent duplicate players
        }
      }
      if (this.$refs[videoPlayerRef] == null) {
        return; // Ensure the video element exists
      }

      this.showPlayer.push(videoPlayerRef);
      
      // Fallback to HLS or other formats
      let videoType = "application/x-mpegURL";
      const adsEnabled = this.hasAdsEnabled(this.user_id);
      console.log(this.user_id, 'userId'); 
      console.log(adsEnabled, 'ads enabled');
      let file =
        getEnv("AWS_URL") +
        getEnv("VIDEO_BUCKET") +
        "/" +
        fileName.slice(0, -4) +
        "/video.m3u8";
      
      const preRollfile = adsEnabled && this.randomizedAds.length > 0
        ? getEnv("AWS_URL") + getEnv("VIDEO_BUCKET") + "/" + this.randomizedAds[0].slice(0, -4) +
        "/video.m3u8"
        : null;

      const postRollfile = adsEnabled && this.randomizedAds.length > 1
        ? getEnv("AWS_URL") + getEnv("VIDEO_BUCKET") + "/" + this.randomizedAds[1].slice(0, -4) +
        "/video.m3u8"
        : null;
      
      
      if (isLink) {
        if (fileName.search(".mp4") != -1) {
          videoType = "video/mp4";
        } else if (fileName.search(".m3u8") != -1) {
          videoType = "application/x-mpegURL";
        } else if (fileName.search(".mov") != -1) {
          videoType = "video/quicktime";
        } else if (fileName.search(".flv") != -1) {
          videoType = "video/x-flv";
        }
        file = fileName;
      }

      // Check if premiere_date is in the past
      let autoPlay = false;
      if (this.$route.name == "story" || this.$route.name == "storyview") {
        autoPlay = 'muted';
      }
      
      let adConfig = {
        main: {
          src: file,
          type: videoType,
        },
      };
      if (adsEnabled) {
        adConfig = {
          preroll: preRollfile
            ? {
              src: preRollfile,
              type: "application/x-mpegURL",
            }
            : null,
          main: {
            src: file,
            type: videoType,
          },
          postroll: postRollfile
            ? {
              src: postRollfile,
              type: "application/x-mpegURL",
            }
            : null,
        };
      }
      
      console.log(adConfig, 'ad config');
      const options = {
        autoplay: autoPlay,
        controls: true,
        nativeControlsForTouch: true,
        preload: "metadata",
        responsive: true,
        fluid: true,
        muted: true,
        playsinline: true,
        bigPlayButton: false,
        sources: [
          {
            src: adConfig.preroll?.src || adConfig.main.src,
            type: adConfig.preroll?.type || adConfig.main.type,
          },
        ],
        controlBar: {
          children: [
            "playToggle", // Play/pause button
            "volumePanel", // Mute/unmute button
            "progressControl", // Seek bar
            "remainingTimeDisplay", // Remaining time display
            "currentTimeDisplay", // Current time display
            // Exclude "progressControl" to hide the seek bar
          ],
        },
        customData: {
          premiere_date: this.premiere_date, // Pass premiere_date
          time_est: this.time_est, // Pass time_est
        },
      };

      console.log('Autoplay option:', options.autoplay);
      console.log('Video ref:', this.$refs[videoPlayerRef]);
      videojs.addLanguage("en", {
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "This Video is processing and may take a few minutes.",
      });
      
      const vm = this; 

      this.player.push(
        videojs(this.$refs[videoPlayerRef], options, function onPlayerReady() {
          console.log("Video.js player is ready"); 
          this.on('autoplayFailed', function() {
            // Show a play button or notify the user
            console.log('Autoplay failed, showing play button');
            this.bigPlayButton.show();
          });

          this.on('playing', function() {
            console.log('remove poster (playing event)');
            this.poster('');
            if (this.currentSrc() === adConfig.preroll?.src) {
              // Show skip button
              console.log('Preroll ad is playing');
              vm.showSkipAd = true;
            } else {
              vm.showSkipAd = false;
            }
          });

          // Access premiere_date and time_est from options.customData
          const { premiere_date, time_est } = this.options_.customData;

          // Ensure startTime does not exceed video duration
          this.on("loadedmetadata", () => {
            let startTime = 0;

            // Check if premiere_date is in the past
            if (premiere_date) {
              if (premiere_date.isBefore(time_est)) {
                // Calculate the difference in seconds
                startTime = Math.floor(time_est.diff(premiere_date, "seconds"));
                console.log(`Premiere date is in the past. Starting video at ${startTime} seconds.`);
              }else{
                this.controls(false); // Disable controls
                this.pause(); // Ensure the video is paused
                this.poster(this.poster()); // Show the poster image
                console.log("Video is not played as per the requirement");
              }
            }

            const videoDuration = this.duration(); // Get the video duration
            console.log(`Premiere date: ${premiere_date}`);
            console.log(`Current time: ${time_est}`);
            console.log(`Video duration: ${videoDuration} seconds, startTime: ${startTime} seconds`);
            if (startTime > videoDuration) {
              console.warn(`startTime (${startTime}s) exceeds video duration (${videoDuration}s). Resetting to 0.`);
              startTime = 0; // Reset startTime to 0 if it exceeds the duration
            }

            // Seek to the startTime if it's valid
            if (startTime > 0) {
              console.log(`Seeking to start time: ${startTime} seconds`);
              this.currentTime(startTime); // Programmatically set the start time
              this.controlBar.removeChild("progressControl"); // Hide the seek bar
              this.controlBar.removeChild("remainingTimeDisplay"); // Hide the seek bar
              //this.controls(false); // Hide controls
              console.log("Controls hidden");
            }
          });

          // Handle video ending and playlist transitions
          this.on("ended", () => {
            vm.showSkipAd = false;
            if (this.currentSrc() === adConfig.preroll?.src) {
              console.log("Preroll ad ended. Playing main video...");
              this.src(adConfig.main.src); // Switch to the main video
              this.play();
            } else if (this.currentSrc() === adConfig.main.src && adConfig.postroll) {
              console.log("Main video ended. Playing postroll ad...");
              this.src(adConfig.postroll.src); // Switch to the postroll video
              this.play();
            } else if (this.currentSrc() === adConfig.postroll?.src) {
              console.log("Postroll ad ended. Restarting playlist...");
              this.src(adConfig.main.src); // Reset to the main video
              this.currentTime(0); // Start from the beginning
              this.play(); // Play the main video
            }
          });
        })
      );
      const createdPlayer = this.player[this.player.length - 1];
      createdPlayer.adConfig = adConfig;
    },
    async presentLoading(message) {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: message,
        });
      await this.loadingIndicator.present();
    },
    async getImageData() {

      let response = await this.$store.dispatch("pikstream/imageData", {
        url: "pikstream/stream-image?id=" + this.story.piklist_id + "&image_id=" + this.pik_id
      });
      if (response) {
        if (response.error != undefined) {
          //this.loadingIndicator.dismiss();
          console.log('Error: ' + response.error);
        } else {
          //console.log(response, 'story');
          /* let title = this.story.piklist_name;
          if(title=='') title = getEnv('APP_NAME');
          this.$store.dispatch("header/custom", {
            title: title,
            description: response.description,
            url: 'https://' + getEnv('SHARE_HOSTNAME') + '/story/' + this.pik_id,
            pik_name: this.path + '/piks/' + this.pik_name,
            width: this.width,
            height: this.height 
          }); */
          this.pik_path = response.pik_path;
          this.origin_date = response.origin_date;
          this.description = response.description;
          this.totalcomments = response.totalcomments;
          this.likes = response.likes;
          this.cute = response.cute;
          this.lol = response.lol;
          this.loveit = response.loveit;
          this.greatshot = response.greatshot;
          this.cool = response.cool;
          this.dislike = response.dislike;
          this.wow = response.wow;
          this.likeit = response.likeit;
          this.likeittype = response.likeittype;
          this.numberRepost = response.numberRepost;
          this.numberViews = response.numberViews;
          this.originator_id = response.originator_id;
          this.originator_username = response.originator_username;
          this.user_id = response.user_id;
          this.user_name = response.user_name;
          this.pikd_pik_id = response.pikd_pik_id;
          //this.type = response.type;
          this.link_url = response.link_url;
          this.link_text = response.link_text;
          this.link_image = response.link_image;
        }
      }
    },
    async goToFeaturedImage() {
      //console.log( this.$route.name, 'checking go to');
      if (this.imageSelected != 0 && (this.$route.name == 'story' || this.$route.name == 'storyview')) {
        //console.log("selected");
        //console.log(this.imageSelected, 'slide image id');
        //console.log(this.story.allimages, 'story images');
        let newIndex = 0;
        for (var i = 0; i < Object.keys(this.story.allimages).length; i++) {
          if (this.story.allimages[i] != null && this.story.allimages[i].id == this.imageSelected) {
            newIndex = i;
          }
        }
        //console.log(newIndex, 'new index');
        //let storySliderRef = "storySlider" + this.index;
        let storySliderRef = "storySlider" + this.story.piklist_id;
        //console.log(storySliderRef, 'story ref');
        var slider = await this.$refs[storySliderRef].swiper;
        //console.log(slider);
        slider.slideTo(newIndex, 500);
        this.$emit('update:refocus', this.story.pik_id);
      }
    },
    adClick(isAd) {
      if (isAd) {
        return "ad-click";
      } else {
        return "";
      }
    },
    /* async adLink(isAd, link_url, image) {
      if (isAd == "Y") {
        if (link_url != "" && link_url != undefined) {
          await Browser.open({ url: link_url });  
          //window.open(link_url, '_blank');
        }
      } else if(type==1){
          console.log(image);
          this.openFullScreen(image, width, height);
        } 
      return;
    },*/
    async didClick(isAd) {
      if (isAd == "Y") {
        if (this.link_url != "" && this.link_url != undefined) {
          await Browser.open({ url: this.link_url }); 
          //window.open(link_url, '_blank');
        }
      } else if (this.type == 1) {
        this.openFullScreen(this.path + '/piks/' + this.pik_name, this.width, this.height);
      } else if (this.type == 3 && this.link_video == '') {
        this.openLink(this.link_url);
      }
      return;
    },
    async openFullScreen(image, width, height) {
      const modal = await modalController
        .create({
          component: PhotoView,
          cssClass: 'fullscreen',
          componentProps: {
            image_id: this.pik_id,
            image: image,
            width: width + 'px',
            height: height + 'px'
          }
        })
      await modal.present();

      //const { role } = await modal.onDidDismiss();
      //console.log(role);
      },
    async openLink(link_url) {
      if (link_url != '') {
        await Browser.open({ url: link_url });
        //window.open(link_url, '_blank');
      }
    },
    async openLinkVideo(link_url, isVideo) {
      if (link_url != '' && !isVideo) {
        await Browser.open({ url: link_url });
        //window.open(link_url, '_blank');
      }
    },
    getHostName(url) {
      var match = '';
      if (url != '' && url != undefined) {
        match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
      }
      if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
      } else {
        return null;
      }
    },
    async openBuyModal(user_id) {
      if (this.$store.state.auth.token != '') {
        await this.presentLoading(this.$t('loadmessage.loading'));
        let profileData = await this.$store.dispatch("profile/otherUserInfo", { userId: user_id });
        //console.log(profileData, 'profile data');
        if (profileData != null) {
          let profile = this.$store.state.profile.profilePageData[user_id];
          let title = this.$t('buttons.premiumcontent');
          let isMyProfile = false;
          if (profile.id == this.$store.state.profile.id) {
            isMyProfile = true;
          }
          this.loadingIndicator.dismiss();
          const modal = await modalController
            .create({
              component: BuyModal,
              cssClass: 'modal-custom-class',
              componentProps: {
                title: title,
                //user_id: user_id
                profile: profile,
                isMyProfile: isMyProfile
              }
            })
          await modal.present();
          const { role } = await modal.onDidDismiss();
          //console.log(role);
          if (role == "subscribed") {
            //console.log('subscribed');
            this.$router.push({ name: 'profile', params: { id: user_id } });
          }
        }
      }
    },
    checkPremium() {
      let canView = true;
      if (this.story.isPremium == 'yes' && this.story.canViewPremium == 'no') {
        canView = false;
      }
      return canView;
    },
    checkIosApp() {
      let iosCheck = false;
      if (isPlatform('hybrid') && isPlatform('ios')) {
        iosCheck = true;
      }
      return iosCheck;
    },
    isTextOnly() {
      let textOnly = 0;
      if (this.type == '3' && this.link_url == '') {
        textOnly = 1;
      }
      return textOnly;
    },
    isEmbed(link) {
      let position = link.toLowerCase().search("/embed/");
      let youtubeLink = false;
      if (position != -1) {
        youtubeLink = true;
      }
      return youtubeLink;
    },
    linkVideoCheck(link_video, playerIndex) {
      let canShow = true;
      if (link_video != '' && link_video != null) {
        if (this.isEmbed(link_video)) {
          canShow = false;
        } else if (this.showPlayer.indexOf(playerIndex) > -1) {
          canShow = false;
        }
      }
      return canShow;
    },
    registerView() {
      var sliderImage = this.story.allimages[0];
      //console.log(sliderImage.id, 'register view');
      this.$store.commit("helpers/setViews", [null, sliderImage.id]);

      var difference = (Date.now() - this.$store.state.helpers.viewsTimestamp) / 1000;
      if (difference > 60) {
        this.$store.dispatch("helpers/postViews");
      }
    },
    imgUrlAlt(event) {
      event.target.src = "/assets/link.png";
    },
    imgUrlAlt2(event) {
      event.target.src = "/assets/link2.png";
    },
    skipAd(videoPlayerRef) {
      const playerIndex = this.player.findIndex(
        p => p.id_ === videoPlayerRef
      );
      const player = this.player[playerIndex];
      if (player && player.currentSrc() === player.adConfig.preroll?.src) {
        player.dispose();

        this.$nextTick(() => {
          const container = this.$refs.videoContainer;
          const oldVideo = this.$refs[videoPlayerRef];
          if (oldVideo && oldVideo.parentNode) {
            oldVideo.parentNode.removeChild(oldVideo);
          }
          const newVideo = document.createElement('video');
          newVideo.setAttribute('class', 'video-js vjs-default-skin ' + this.calculateAspectRatio());
          newVideo.setAttribute('width', this.width);
          newVideo.setAttribute('height', this.height);
          newVideo.setAttribute('playsinline', '');
          newVideo.setAttribute('muted', '');
          newVideo.setAttribute('preload', 'metadata');
          newVideo.setAttribute('ref', videoPlayerRef);
          newVideo.setAttribute('id', videoPlayerRef);
          newVideo.setAttribute('poster', this.path + '/piks/' + this.pik_name);

          container.appendChild(newVideo);

          const options = {
            autoplay: true,
            controls: true,
            muted: true,
            playsinline: true,
            bigPlayButton: false,
            sources: [{
              src: player.adConfig.main.src,
              type: player.adConfig.main.type
            }]
          };
          const newPlayer = videojs(newVideo, options, function() {
            this.play();
          });

          // Restore adConfig
          newPlayer.adConfig = player.adConfig;

          // Restore event listeners for postroll and playlist logic
          newPlayer.on("ended", function() {
            // Use the same logic as in setVideoOptions
            if (this.currentSrc() === newPlayer.adConfig.main.src && newPlayer.adConfig.postroll) {
              this.src(newPlayer.adConfig.postroll.src);
              this.play();
            } else if (this.currentSrc() === newPlayer.adConfig.postroll?.src) {
              this.src(newPlayer.adConfig.main.src);
              this.currentTime(0);
              this.play();
            }
          });

          this.player[playerIndex] = newPlayer;
          this.showSkipAd = false;
        });
      }
    },
  },

  watch: {
    imageSelected() {
      //console.log('watching slide');
      this.goToFeaturedImage();
    }
  },
  computed: {
    ...mapGetters("ads", ["hasAdsEnabled"]),
    videoLocked() {
      // Video is locked if premiere_date is in the future
      return this.premiere_date && this.time_est && this.premiere_date.isAfter(this.time_est);
    }
  },
});
</script>
<style scoped>
.video-js .vjs-icon-next-item {
  font-size: 18px;
}

.video-js .vjs-big-play-button {
  width: 0px;
  height: 0px;
  display: none;
}

/* Add to your <style scoped> */
.skip-ad-btn {
  position: relative;
  top: -64px;
  float: right;
  left: 0px;
  width: 90px;
  z-index: 10;
  background: rgba(0,0,0,0.7);
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.9em;
}


</style>
